import { CaptionedImage } from './CaptionedImage';
import { useNicheNominal } from '@/hooks';
import { Skeleton } from '@mui/material';

export function CaptionedNominalImage({ nominalId }) {
  const {
    query: { data: nominal, isLoading, isFetching },
  } = useNicheNominal(nominalId, { image: true });

  if (isLoading || isFetching) {
    return <Skeleton variant="rounded" sx={{ minWidth: 240 }} height={320} />;
  }

  if (!nominal) {
    return null;
  }

  return (
    <CaptionedImage
      imageSrc={nominal?.imageSrc}
      height={320}
      fallbackWidth={240}
      alt="Nominal"
      topCaption={nominalId}
      bottomCaption={[nominal?.forenames, nominal?.surname]
        .filter(Boolean)
        .join(' ')
        .toLowerCase()}
      bottomCaptionProps={{ sx: { textTransform: 'capitalize' } }}
    />
  );
}
